module.exports = __webpack_public_path__ + "static/img/wave.bd64a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wave.png
// module id = Ea9E
// module chunks = 1